/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../../../../../components/ui-elements/table/StyledTableCell';
import StyledTableRow from '../../../../../components/ui-elements/table/StyledTableRow';
import { Grid } from "@mui/material";
import { useEffect } from 'react';
import { useState } from 'react';
import Loader from '../../../../../components/ui-elements/loader';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
  
import { Stack, Tooltip } from '@mui/material';
 import { getAllPersonnelUserList } from '../../../../../store/reducers/personnel/personnelAction';
import PersonnelRevokeUser from './personnelRevokeUser';
import PersonnelGrantUser from './personnelGrantUser';
import PersonnelDropUser from './personnelDropUse';
import PersonnelViewGrants from './personnelViewGrants';
const PersonnelUserList = () => {
    const [loading, setLoading] = useState(false);
    const users = useSelector(state => state.personnel.personnelUsers);
    const dispatch = useDispatch();


    const fetchUsers = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(getAllPersonnelUserList()).unwrap();

            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        fetchUsers()
    }, [fetchUsers]);

    return (
        <>
            {!loading ? <>
                <Grid container justify="center">

                    <Grid xs={12} sm={12} md={12}>

                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <StyledTableRow>
                                        <StyledTableCell label="User Name" />
                                        <StyledTableCell label="" />

                                    </StyledTableRow>

                                </TableHead>
                                <TableBody>
                                    {users?.length > 0 && users?.map((row) => (
                                        <React.Fragment key={row.User}>

                                            <StyledTableRow >
                                                <StyledTableCell label={row.User} />
                                                <StyledTableCell align="right">
                                                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                                                        <PersonnelViewGrants userName={row.User} />

                                                        {/* Grant */}
                                                        <Tooltip title="Grant Access">
                                                            <span>
                                                                <PersonnelGrantUser userName={row.User} />
                                                            </span>
                                                        </Tooltip>


                                                        {/* Revoke */}
                                                        <Tooltip title="Revoke Access">
                                                            <span>
                                                                <PersonnelRevokeUser userName={row.User} />
                                                            </span>
                                                        </Tooltip>
                                                        {/* Drop */}
                                                        <Tooltip title="Drop User">
                                                            <span>
                                                                <PersonnelDropUser userName={row.User} />
                                                            </span>
                                                        </Tooltip>

                                                    </Stack>
                                                </StyledTableCell>
                                            </StyledTableRow>

                                        </React.Fragment>

                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            </> : (<Loader />)}

        </>
    )

}

export default PersonnelUserList;
